var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCity = function SvgCity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M473.901 482V321.972H301.544V482h-30V291.972h101.179V120.878h-33.726V53.847h-38.163V0h-30v53.847H232.67v67.031h-33.726V482h-30V187.91H38.099V482H0v30h512v-30zM304.349 157.91h30v30h-30zm0 67.031h30v30h-30zm-186.49 245.294h-30v-30h30zm0-71.765h-30v-30h30zm0-71.764h-30v-30h30zm0-71.765h-30v-30h30zm149.459 0h-30v-30h30zm0-67.031h-30v-30h30zm3.515-97.032h30v30h-30zM368.997 482h-30V361.6h30zm67.452 0h-30V361.6h30z"
  })));
};
export default SvgCity;